import { getNewGames } from './../utils';
import config from '../../../config';
import { LogicContext } from '../types';
import AlgoliaFactory from '../../../model/algolia';

export const fetchSearchGames = async (context: LogicContext) => {
  const Algolia = AlgoliaFactory({
    ...config.algolia.config,
  });
  const phrase = context.search.searchPhrase;

  if (!phrase || phrase.length < 3) {
    return {
      games: context.games,
      search: {
        ...context.search,
        searchItems: [],
      },
    };
  }

  const filters = [
    `${config.viewer_country}-${config.viewer_region}`,
    `${config.viewer_country}-EMPTY`,
    'EMPTY',
  ];

  const { items: searchItems, queryID, userToken } = await Algolia.searchItems(
    phrase,
    filters,
    config.locale,
    config.base_path
  );

  const newGames = getNewGames(searchItems);

  return {
    games: {
      ...context.games,
      ...newGames,
    },
    search: {
      ...context.search,
      searchItems,
      currentType: 'All',
      queryID,
      userToken,
    },
  };
};
